if (!customElements.get('product-subscribe')) {
  class ProductSubscribe extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.handleChange.bind(this);
    }

    isRechargeAppPlan(select) {
      const selected = select.options[select.selectedIndex];
      return selected && selected.dataset.appId === '294517';
    }

    handleSelect(select) {
      if (!select) return;

      const oneTime = this.querySelector('[js-one-time]');
      if (oneTime?.checked) return;

      if (!select.value && select.options.length) {
        select.value = select.options[0].value;
      }

      if (!this.isRechargeAppPlan(select)) return;

      const rcSelect = document.querySelector('[name="rc_selling_plan"]');
      if (!rcSelect) return;

      rcSelect.value = select.value;
      rcSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleChange(event) {
      const select = this.querySelector('[js-plan-select]');
      if (!select) return;

      if (event.target.tagName === 'SELECT') return this.handleSelect(select);

      const subscribe = this.querySelector('[js-subscription]');
      const oneTime = this.querySelector('[js-one-time]');
      const url = new URL(window.location.href);
      const rechargeSubscribe = document.querySelector('[value="subscription"]');
      const rechargeOneTime = document.querySelector('[value="onetime"]');

      if (rechargeSubscribe) {
        rechargeSubscribe.checked = subscribe.checked;
        rechargeSubscribe.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (rechargeOneTime) {
        rechargeOneTime.checked = oneTime.checked;
        rechargeOneTime.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (oneTime.checked) {
        select.setAttribute('name', 'no_plan');
        url.searchParams.delete('selling_plan');
      } else {
        if (!select.value && select.options.length) {
          select.value = select.options[0].value;
        }

        if (this.isRechargeAppPlan(select)) {
          select.setAttribute('name', 'selling_plan');
          url.searchParams.set('selling_plan', select.value);
        } else {
          select.setAttribute('name', 'no_plan');
          url.searchParams.delete('selling_plan');
        }

        this.handleSelect(select);
      }

      window.history.replaceState({}, '', url.toString());
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange);

      const select = this.querySelector('[js-plan-select]');
      if (!select) return;

      const oneTime = this.querySelector('[js-one-time]');
      const isRecharge = this.isRechargeAppPlan(select);
      select.setAttribute('name', (oneTime?.checked || !isRecharge) ? 'no_plan' : 'selling_plan');
    }
  }

  customElements.define('product-subscribe', ProductSubscribe);
}
